import React, { useEffect, useState, Suspense } from 'react';
import { LandingHeader } from './LandingHeader';
import { SimpleFooter } from '../footer/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthToken } from '../../hooks/useAuthToken';
import { useUserPlan } from '../../hooks/useUserPlan';
import { PLAN_TYPE_EAN_STUDENT_TACHER_COLLABORATOR } from '../../assets/constants';
import { AcceptDialog } from '../controls/UIControls';
import WebChatZoomCrm from '../../assets/zoom-messenger-react/lib/addBubble.js';
const landingImages = require.context('../../assets/images', true);

export const LandingPage = () => {
  const navigate = useNavigate();
  const [eanuserDialog, setEanuserDialog] = useState(false);
  const { authToken, isLogged } = useAuthToken();
  const { checkUserPlan } = useUserPlan();
  const [eanActivePlan, setEanActivePlan] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (isLogged()) {
      checkUserPlan(authToken).then((hasPlan) => {
        if (hasPlan && hasPlan.planType == PLAN_TYPE_EAN_STUDENT_TACHER_COLLABORATOR) {
          setEanActivePlan(true);
        }
      });
    }
  }, []);

  const showEanDialog = (e) => {
    e.preventDefault();
    setEanuserDialog(true);
  };
  window.addEventListener('scroll', function () {
    if (this.window.scrollY > 100) {
      const elements = this.document.getElementsByClassName('landing__whatsapp-button-static');
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        element.classList.add('landing__whatsapp-button');
        element.classList.remove('landing__whatsapp-button-static');
      }
    }
  });
  return (
    <>
      <LandingHeader />
      <div id="contWebChatZoomCrm">
        <WebChatZoomCrm
          elementId="contWebChatZoomCrm"
          backgroundColor="#3BAC53"
          color="#FFFFFF"
          socialGatewayUrl="https://socialgateway.verzia.io/modules/zoomWebChat/zoomMessengerLog.php?params=N3hMWEdVWndFVytYQnE4cU4xSm1pMlhRaHVvSXVPRmVuNjQrdGFvS0o4cTZaOSt2eFEyNmhoM1Y3TDk1MWNXZFhUbld3YXlEOUdEUlliTUVvYkFkVGEvMHJlNS9pQVFyTXc1MTVOZGNPRW9LN0VsZFNwdFllRFBCVzhrYm1HZ1YyeXFDVE9TUlZYdTBuUE9TbnVaTHM2RkNJVGErSGNDTTFvek5EeXNuc3dhOTJ6RG1TcXdGSmV2eFMwbEJZSmtuUzA0M2cxQ2c5cEpwV1Y2Z1pGZ3lmZ3JHeVp0cFdxTk5UaWZVSStQMmZYR2gxWXVwV2tUWithQzFxTnIwSzFTZmdtenNva0U5NHlaM3pxY3RJVkFQUnl6d1N4MHJONFplem1EN3o5dGc3VUkrR0U3Z05BekE0V2NKNW9NRjl3dldVMUYyUnRYV05yeFk0Q2dDR1VtTDdRd1FtL1BkVUp5U01obktRN2lSeThuWWJaZmtMTkUrcjgyVFFJMFFCM1NKM1p4ckNOUW5sTy9LYWFWbWhqYTJYQWtXTEVjbXoyNDRFd2s1OXNsTlI2R0VuNmVNdHhEbE1hQVdRTER0Wk5rcnVkU0g3Wk9TNmc3QkJRUlRkTnJDbHA2ZXpvVW5SbkFjMlFFK2xLUmhVUHRPQU83S0xmOWd6elkvZ01XeTdqM1BoaDIwQzFEMk12N2pUZitJNFMwYkdFcWUweHJyeFlNSUwxWkhMUXFxMlpCRUpUZFY3dGpsazdBcEtoRS9OdjlrdnphUDcrTnNWQ0xXQWJRWjBMTXlBQmJuekxleFZDbzBWcDkyUzU2dks5b0NxT3l0Vk4xRk5Majlldytqcy9hbk1nSndTVVBRRXlZQlVuMitsYkNpVGtTaVhRdElaa0VyVDMvc3pNSjRvUUdnUlpOdVV5NWpsOUJJSjhnY0hQbC80Z2s5YjE3akZraHVwZ0EzZitFdFIzSEloTERJM0ozSUlua3RZMTNQdm02ZERVM0ZUdjBsaUVLTjk0SGxEN2Y2KzRjWDNXS2tqakVlWGhlRmdxY1Z0WnNWSVhJVjdTclljV09QaUFQbWxsSE1xWldoUzdlN3BGSWtqb0dJV0l5cmFnNnFqNEtWc3VuRnhmNmhsY1FTa1NINGZNYlJBYkdSU2pZZlpKM3d4S1R3MUZrQkpRbVJyVG00SWFYS1RvVzNmOWNTbHF4WWNXWGRZVmV0QXZ5M3V6d1B5TkdpbXhORXJjTUdoWDRQWmo1Z1RxcWxGTzFNNWt4RWZQakh3QzNNcm9GU0hXcGNldDkwR01CbGhmMHlXQ09pck1oT3o4S1NrVkw1U1dNQUY0aURuampZMHBrdldBN0xHUlNmeSt1M0hNbm1iNXV4REh4bWJ3R1VSWFZFaXhnR0ZwQVV5MWhadFZTV1htelFZYjdzR3Y4VE5OY2svQjNMZjdHY0h0MGFCR2lSdEF1TkhmQ2lSZFBDV2VMczQ3ZXU1N1FzZzA5RmxDd21JV3R1WkE1WWJIclFCamJNKytuNVhNeE1TempUTXEzY1lYY0QxSzBmQ01GZnp5bHhna0lrYVB3Y1BVTW11TU45TUxRLzczYz0="
        />
      </div>
      <AcceptDialog
        open={eanuserDialog}
        message="Ya disfrutas de un plan B2B."
        style="info"
        afterClose={() => setEanuserDialog(false)}
      ></AcceptDialog>
      <div className="landing__container-eres-comunidad-eanista mt-5">
        <div className="container me-lg-0 my-5 ms-lg-auto">
          <div className="row justify-content-lg-end align-items-center">
            <div
              className="col-12 d-block d-lg-none"
              style={{ overflow: 'hidden', textAlign: 'center', margin: '0 auto' }}
            >
              {/* <img alt='Men looking at laptp' src={landingImages('./men-laptop-medium.png')} style={{width: "60%", height: "auto",minWidth: "100%", maxWidth: "none", margin: "0 -100%"}}/> */}
              <img
                alt="Men looking at laptp"
                src={landingImages('./placeholder-home.png')}
                className="img-fluid"
                width="516"
                height="348"
              />
            </div>
            <div className="col-xl-4 col-lg-5 col-md-10 col-12">
              {/*<div className='row'>
                            <div className='col-12 landing__text-eres-comunidad-eanista'><span className='landing__text-color-green'>Elige el curso que más te llame la atención</span>
                            </div>
                        </div>*/}
              <div className="row my-4">
                <div className="col-12 landing__paragraph-text">
                  <p className="landing__text-color-dark-green">
                    El curso &quot;Cápsula de Inglés: Guianza Ecológica&rdquo; es una formación en
                    línea diseñada para mejorar tus habilidades en inglés, enfocándose en el ámbito
                    de la guianza ecológica.{' '}
                  </p>
                  <p className="landing__text-color-dark-green">
                    EanX se destaca por su enfoque práctico, permitiendo a los estudiantes aplicar
                    lo aprendido en su vida personal y profesional.
                  </p>
                  <p className="landing__text-color-dark-green">
                    La plataforma busca democratizar el acceso a la educación de calidad, ofreciendo
                    oportunidades de formación en habilidades profesionales, humanas y digitales.
                  </p>
                  <p className="landing__text-color-dark-green">
                    Este curso es ofrecido por Livehappy y EanX, la plataforma de educación digital
                    de la Universidad Ean, que proporciona más de 600 cursos gratuitos y
                    certificables en diversas áreas.{' '}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-xl-8 d-flex justify-content-end pe-0 d-none d-lg-grid">
              {/* <img alt='Men looking at laptp' src={landingImages('./men-laptop.png')} style={{width: "100%", height: "auto"}}/> */}
              <img
                alt="Men looking at laptp"
                src={landingImages('./placeholder-home.png')}
                className="img-fluid"
                width="822"
                height="478"
              />
            </div>
          </div>
        </div>
      </div>
      <SimpleFooter />
    </>
  );
};
